// extracted by mini-css-extract-plugin
export default {"container":"ShiftTimeOffModal--container--11c5b7","dates":"ShiftTimeOffModal--dates--10fa4a","attentionContainer":"ShiftTimeOffModal--attentionContainer--5605f8"};